export const TOPICS = [
    "Programming",
    "Design",
    "School",
    "Life in Korea",
    "Business",
    "Freelancing",
    "Music"
]